import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../store';
import { Csv, getCsvs } from '../../api/csv';
import { CsvSlice } from './types';

const initialState: Array<CsvSlice> = [
  {
    id: 414,
    schedule_csv_id: null,
    monitor_id: 2,
    station_id: 5,
    account_id: 1,
    requester_id: 1992,
    recipient_id: 1992,
    start: "2020-07-21 08:00:00",
    end: "2020-07-21 18:00:00",
    data_filter_1: "0",
    data_filter_2: null,
    data_filter_3: "0",
    filename: "Leq_test_1_2020_07_21_0800-2020_07_21_1800_R.csv",
    created: "2020-07-21 16:23:50",
    status: 1
  }
];

export const csvsSlice = createSlice({
  name: 'csvs',
  initialState,
  reducers: {
    loadCsvs: (state, action: PayloadAction<CsvSlice[]>) => {
      return action.payload;
    }
  }
});

export const { loadCsvs } = csvsSlice.actions;

export const fetchCsvs = (station_id: number): AppThunk => async (dispatch, getState) => {
  const { user } = getState()
  
  try {
    const reports = await getCsvs(user.api_key, station_id)

    dispatch(loadCsvs(reports));
  } catch (err) {
    console.error(err.toString())
  }
}

export const slectAllCsvs = (state: RootState) => {
  return state.csvs;
}

export default csvsSlice.reducer;
